import {Component, OnInit} from '@angular/core';

import {ReportingFields} from './reports.interfaces';
import {ReportsService} from './reports.service';

@Component({
  selector: 'report',
  template: '<router-outlet></router-outlet>'
})

export class ReportComponent implements OnInit {
  constructor(private reportsService: ReportsService) {

  }

  public ngOnInit(): void {
    this.reportsService.isFieldsLoaded = true;
    this.reportsService.getReportingFields()
      .subscribe((response: ReportingFields) => {
        this.reportsService.fieldsSubject.next(response);
        this.reportsService.isFieldsLoaded = false;
      });
  }
}
